import { render, staticRenderFns } from "./RescheduleRequestsPage.vue?vue&type=template&id=1f993916"
import script from "./RescheduleRequestsPage.vue?vue&type=script&lang=js"
export * from "./RescheduleRequestsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports